import React from 'react';
import PropTypes from 'prop-types';

import { useMonth } from '@spa/shared/hooks/dateRange';
import { MonthContainer, RowContainer } from './styles';
import Day from './day';

const Month = ({ year, month, dateRange }) => {
  const { firstDayOfWeek } = dateRange;
  const { days } = useMonth({ year, month, firstDayOfWeek });

  return (
    <MonthContainer role="presentation">
      <tbody>
        {days.map((week, chunk) => (
          <RowContainer key={chunk}>
            {week.map(({ date, dayLabel } = {}, index) =>
              date && dayLabel ? (
                <Day date={date} dateRange={dateRange} key={date.toString()} dayLabel={dayLabel} />
              ) : (
                <Day dateRange={dateRange} key={`${chunk - index}`} />
              )
            )}
          </RowContainer>
        ))}
      </tbody>
    </MonthContainer>
  );
};

Month.propTypes = {
  year: PropTypes.number.isRequired,
  month: PropTypes.number.isRequired,
  dateRange: PropTypes.object.isRequired
};

export default Month;
